import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheTrainingRoom from "./sections/TheTrainingRoom";
import VitaPhilosophie from "./sections/VitaPhilosophie";
import HealingMethods from "./sections/HealingMethods";
import BerichteNeuigkeiten from "./sections/BerichteNeuigkeiten";
import ImpressionsFromSoonwald from "./sections/ImpressionsFromSoonwald";
import PhotoGallery from "./sections/PhotoGallery";
import StimmenUnsererKlienten from "./sections/StimmenUnsererKlienten";
import TrustThroughExpertise from "./sections/TrustThroughExpertise";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheTrainingRoom />
      <VitaPhilosophie />
      <HealingMethods />
      <BerichteNeuigkeiten />
      <ImpressionsFromSoonwald />
      <PhotoGallery />
      <StimmenUnsererKlienten />
      <TrustThroughExpertise />
      <Footer />
    </div>;
}